// The Hidden Treasure Cave's signed-out sign-in screen (PROTO cave.html).
// Rendered by CaveArea directly inside PublicLayout's dark `cave-main` —
// NOT inside `.chv-app` (that wrapper only exists once a session exists) —
// so this reaches for the shared public-site classes (`opener`, `prose`,
// `pill`) and the `html.dark main` tokens (--gold, --parch, --body-ink),
// never the `--chv-*` members' area tokens.
import { useRef } from 'react';
import { DISCORD_SIGNIN_URL } from '../api.js';
import { Opener } from '../site/Opener.js';
import { useReveal } from '../site/motion.js';
import styles from './Landing.module.css';

export function Landing({ signinMessage }: { signinMessage: string | null }) {
  const scopeRef = useRef<HTMLDivElement | null>(null);
  useReveal(scopeRef);

  return (
    <div ref={scopeRef}>
      <Opener lines={['Hidden', 'Treasure Cave']} />
      <section className="wrap section">
        <div className="prose big narrow" data-reveal>
          <p>Crew only. Sign in with your Discord account to enter: no password needed.</p>
          {signinMessage && (
            <p className={styles.message} role="status">
              {signinMessage}
            </p>
          )}
          <a className="pill solid" href={DISCORD_SIGNIN_URL}>
            Sign in with Discord{' '}
            <span className="arr" aria-hidden="true">
              →
            </span>
          </a>
        </div>
      </section>
    </div>
  );
}
